import getAPIData from '@/utils/getAPIData';
import isEmptyData from '@/utils/isEmptyData';
import { useEffect, useRef, useState } from 'react';

const usePollingData = (apiEndpoint, initialData = [], interval = 9000) => {
  const [data, setData] = useState(initialData);
  const intervalRef = useRef(null);
  const fetchControllerRef = useRef(new AbortController());

  const clearTimer = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    fetchControllerRef.current.abort('Aborted');
  };

  const fetchData = async () => {
    fetchControllerRef.current = new AbortController();
    try {
      const result = await getAPIData(apiEndpoint, {
        revalidate: 0,
        signal: fetchControllerRef.current.signal
      });
      if (!isEmptyData(result)) setData(result);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Failed to fetch data:', error);
      }
    }
  };

  useEffect(() => {
    clearTimer();
    intervalRef.current = setInterval(async () => {
      await fetchData().catch();
    }, interval);
    return () => clearTimer();
  }, [apiEndpoint, interval]);

  return data;
};

export default usePollingData;
